import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountRoutingModule } from './account-routing.module';
import { DfFormlyModule } from '@lib/fresco';
import { SharedModule } from '@app/shared/shared.module';
import { AutofocusDirective } from '@app/shared/directives/autofocus.directive';

// components
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginViewComponent } from './components/login-view/login-view.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { DgxLoggedOutComponent } from './components/logged-out/logged-out.component';
import { SignupFormComponent } from './components/signup-form/signup-form.component';
import { AccountFormsComponent } from './components/account-forms/account-forms.component';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';

// services
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';

@NgModule({
  declarations: [
    LoginFormComponent,
    LoginViewComponent,
    ResetPasswordComponent,
    SignupFormComponent,
    AccountFormsComponent,
    ForgotPasswordFormComponent,
    ChangePasswordFormComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    AccountRoutingModule,
    DfFormlyModule.forRoot(),
    // FormFieldsModule,

    //standalone components
    AutofocusDirective,
    DgxLoggedOutComponent,
  ],
  exports: [
    LoginFormComponent,
    LoginViewComponent,
    ResetPasswordComponent,
    DgxLoggedOutComponent,
    SignupFormComponent,
    AccountFormsComponent,
    ForgotPasswordFormComponent,
    ChangePasswordFormComponent,
  ],
  providers: [],
})
export class AccountModule {}
